export default {
    setCurrentUser(state, payload) {
        state.currentUser = payload;
    },
    setCurrentUserID(state, payload) {
        state.currentUserID = payload;
    },
    setUserData(state, payload) {
        state.userData = payload;
    }
}